import { RatesWidget } from '@/app_components/common/widgets/RatesWidget/RatesWidget';
import { RedVentureWidgets } from '@/app_data/widgets/RedVentures/constants';
import type { ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';

interface EmbedRatesWidgetsProps {
  postId: number;
}

/** Don't use this unless absolutely necessary. Once the client parser is gone, this will be too */
export const embedRatesWidgetsClient = ({ postId }: EmbedRatesWidgetsProps): ParserRule => ({
  insertComponent: ({ node }) => {
    switch (node.props['data-ad-id']) {
      case RedVentureWidgets.CdRates: {
        return (
          <RatesWidget
            key={node.props['data-ad-id']}
            postId={postId}
            type='CD'
          />
        );
      }
      case RedVentureWidgets.SavingsMma: {
        return (
          <RatesWidget
            key={node.props['data-ad-id']}
            postId={postId}
            type='Savings'
          />
        );
      }
      default:
        return <></>;
    }
  },
  insertPosition: 'replace',
  match: ({ node }) =>
    node.props?.['data-ad-id'] &&
    [RedVentureWidgets.CdRates, RedVentureWidgets.SavingsMma].includes(node.props['data-ad-id']),
});
